var map = {
	"./Chevron_left.svg": 93523,
	"./Initial_avatar.svg": 36716,
	"./Lock_light.svg": 41640,
	"./Logo.svg": 22273,
	"./Logo_icon.svg": 31247,
	"./Mail.svg": 64161,
	"./User.svg": 26349,
	"./View_hide.svg": 13258,
	"./View_show.svg": 20177,
	"./add.svg": 86613,
	"./alert_error.svg": 78301,
	"./alert_success.svg": 87678,
	"./arrow-icon.svg": 92203,
	"./check_icon.svg": 55516,
	"./chevron-down.svg": 90498,
	"./chevron-left.svg": 58921,
	"./circle-information.svg": 76185,
	"./clock_outline.svg": 75817,
	"./close.svg": 3360,
	"./collection.svg": 13728,
	"./document-download.svg": 65200,
	"./download.svg": 40932,
	"./edit.svg": 93992,
	"./empty-font-preview.svg": 53572,
	"./heart_outline.svg": 51279,
	"./icon-gift.svg": 49906,
	"./icon-notebook.svg": 54155,
	"./icon-share.svg": 54473,
	"./icon-store.svg": 46971,
	"./loop-icon.svg": 26776,
	"./marker-tip.svg": 58162,
	"./search.svg": 7584,
	"./shield.svg": 82759,
	"./star_outline.svg": 34763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26066;